import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'

import { APP_NAME } from '../../../../static/constants'
import ReferralImage from '../../../../assets/img/referral-image.webp'
import { postDevices } from '../../../../services/api/requests/Device'
import { LANDING } from '../../../../services/data/registrationSteps.json'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import { setGACustomPageView } from '../../../../services/analytics/google-analytics'

// simplified imports
import LoginForm from '../LoginForm/LoginForm'
import validateLogin from '../../../../services/validation/Login'
import { doValidateMobile } from '../../../../controllers/Registration'
import { Layout as MainLayout } from '../../../../components/ui/SimplifiedLogin'
import {
  Title,
  FormWrapper,
  // StyledLink,
  PerksContainer,
  Perk,
  PerkImage,
  PerkTitle,
  PerkDescription,
} from './MainView.style'
import { ContentContainer } from '../../../simplified.login/components/MainView/MainView.style'
import mapsIcon from '../../../../assets/img/simplified-login/Maps.png'
import perksIcon from '../../../../assets/img/simplified-login/PointsV2.png'
import promosIcon from '../../../../assets/img/simplified-login/RewardsV2.png'
import parkingIcon from '../../../../assets/img/simplified-login/Parking.png'
import { REGISTRATION_STEPS } from '../../../../services/hooks/useRegistrationBanners'
import useFeatureMaintenance, {
  FEATURES_LIST,
} from '../../../../services/hooks/useFeatureMaintenance'

const PERKS = [
  {
    img: perksIcon,
    title: 'Perks',
    desc: 'Ayala Malls special offers',
    color: '#9F49BE',
  },
  {
    img: promosIcon,
    title: 'Promos',
    desc: 'Participate and win prizes',
    color: '#F9831B',
  },
  /*   {
    img: parkingIcon,
    title: 'Parking',
    desc: 'Free Parking Vouchers',
    color: '#00A793',
  }, */
  {
    img: mapsIcon,
    title: 'Maps',
    desc: 'Find your way around the malls',
    color: '#F74961',
  },
]

const MainView = props => {
  const {
    push,
    browser,
    setStep,
    setToken,
    firebase,
    setDevice,
    primaryInfo,
    googleToken,
    location = {},
    setPrimaryInfo,
    doGetFirebaseToken,
    setFirebaseMessagingToken,
  } = props

  const {
    loading,
    isFeatureAvailable,
    refreshFeatureStatus,
  } = useFeatureMaintenance({ feature: FEATURES_LIST.PARKING_VOUCHERS })
  const [perks, setPerks] = React.useState(PERKS)

  React.useEffect(() => {
    setGACustomPageView({
      page: location.pathname,
      title: 'Registration - Mobile Number',
    })
  }, [location.pathname])

  React.useEffect(() => {
    doGetFirebaseToken({
      firebase,
      setFirebaseMessagingToken,
    })
  }, [doGetFirebaseToken, firebase, setFirebaseMessagingToken])

  React.useEffect(() => {
    if (loading) return
    setPerks(PERKS)
  }, [loading])

  React.useEffect(() => {
    refreshFeatureStatus()
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const initialValues = {
    ...location?.state,
  }

  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:title" content={`${APP_NAME} | Register Now`} />
        <meta
          property="og:description"
          content={`Amazing things start here. Register with ${APP_NAME} today.`}
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_BASE_URL}${ReferralImage}`}
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <MainLayout registrationStep={REGISTRATION_STEPS.REGISTER_MOBILE}>
        <ContentContainer minHeight={600}>
          <div>
            <Title>
              Amazing things start here. <br />
              Register and enjoy…
            </Title>
            <FormWrapper>
              <AccessibleForm
                enableReinitialize
                initialValues={initialValues}
                onSubmit={doValidateMobile({
                  push,
                  setStep,
                  setToken,
                  googleToken,
                  setPrimaryInfo,
                  searchString: location.search,
                  appleId: primaryInfo ? primaryInfo.appleId || null : null,
                })}
                method="post"
                action="/a/register"
                validate={validateLogin}
                render={props => <LoginForm {...props} />}
              />
            </FormWrapper>
          </div>
          <PerksContainer>
            {/* FEATURES / PERKS */}
            {perks.map((item, i) => (
              <Perk key={`perk-${i}-${item.title}`}>
                <PerkImage src={item.img} width={item.width} />
                <PerkTitle color={item.color}>{item.title}</PerkTitle>
                <PerkDescription>{item.desc}</PerkDescription>
              </Perk>
            ))}
          </PerksContainer>
          <div />
          <div />
        </ContentContainer>
      </MainLayout>
    </React.Fragment>
  )
}

MainView.defaultProps = {
  primaryInfo: null,
  step: LANDING,
  googleToken: null,
  appleId: null,
  firebaseMessagingToken: null,
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  step: PropTypes.number,
  push: PropTypes.func.isRequired,
  location: PropTypes.shape(),
  googleToken: PropTypes.string,
  referralCode: PropTypes.string.isRequired,
  setPrimaryInfo: PropTypes.func.isRequired,
  setToken: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
  saveAccessToken: PropTypes.func.isRequired,
  setAccessToken: PropTypes.func.isRequired,
  setGoogleToken: PropTypes.func.isRequired,
  setAppleToken: PropTypes.func.isRequired,
  firebaseMessagingToken: PropTypes.string,
  replace: PropTypes.func.isRequired,
  firebase: PropTypes.shape(),
  setFirebaseMessagingToken: PropTypes.func.isRequired,
  doGetFirebaseToken: PropTypes.func.isRequired,
  doSavePrimaryInfo: PropTypes.func.isRequired,
  doGoogleLogin: PropTypes.func.isRequired,
  doAppleLogin: PropTypes.func.isRequired,
  doValidateRegistrationForm: PropTypes.func.isRequired,
  doSubscribeToFirebaseMessaging: PropTypes.func.isRequired,
}

export default withRouter(MainView)
